/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
  SEARCH_TALENTS_REQUEST,
  SEARCH_TALENTS_SUCCESS,
  SEARCH_TALENTS_FAILURE,
} from 'actions/search';

import { REQUEST_TALENT_SUCCESS, SAVE_TALENT_SUCCESS } from 'actions/job';

import {
  ADD_TALENT_SHORTLIST_SUCCESS,
  REMOVE_TALENT_SHORTLIST_SUCCESS,
} from 'actions/shortlist';

const initialState = {
  loading: true,
  query: {},
  pagination: {},
  items: [],
  filter_menu: [],
};

/**
 * This is the talents reducer. It listens for actions and updates the talents state object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(state = initialState, { type, payload }) {
  switch (type) {
    case SEARCH_TALENTS_REQUEST:
      return {
        ...initialState,
        filter_menu: state.filter_menu,
        skill_rows: state.skill_rows,
        loading: true,
      };

    case SEARCH_TALENTS_SUCCESS:
      // NOTE: this should probably be removed in backend
      const filter_menu = payload?.filter_menu || [];
      const filtered_menu = filter_menu.filter(
        ({ tag }) => tag !== 'SKILL_AGENT'
      );

      return {
        ...state,
        ...payload,
        items: payload.talents,
        filter_menu: filtered_menu,
        loading: false,
      };

    case SAVE_TALENT_SUCCESS:
    case REQUEST_TALENT_SUCCESS:
    case ADD_TALENT_SHORTLIST_SUCCESS:
    case REMOVE_TALENT_SHORTLIST_SUCCESS:
      var mergedItems = state.items.map(a => ({
        ...a,
        ...payload.updated_gallery_profiles.find(
          b => b.talent_id === a.talent_id
        ),
      }));

      return {
        ...state,
        items: mergedItems,
      };

    case SEARCH_TALENTS_FAILURE:
      return initialState;

    default:
      return state;
  }
}
